import AxiosInstance from './config/Http'
import Config from './config/Constants'

export default {
  getByIds: (ids: any[]) => {
    return AxiosInstance.get<any[]>(`${Config.core.includedCharges}`,
      { params: {
          "id.in": ids.join('&id.in=')
        }}
    )
  }
}
